import { Grid } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { config as url } from "../../common/config";
import FetchDataContext from "../../context/fetchData/fetchDataContext";
import CommentForm from "./CommentForm";
import CommentList from "./CommentList";
import Jumbotron from "./Jumbotron";
import DialogImages from "./components/DialogImages";
import "./styles.css";


const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		justifyContent: "center",
		backgroundColor: "whitesmoke",
	},
	card: {
		width: "60%",
		padding: theme.spacing(1),
		[theme.breakpoints.down("sm")]: {
			width: "100%",
		},
	},
	jumbotron: {
		padding: theme.spacing(1), //grid padding
		textAlign: "center",
		color: theme.palette.text.secondary,
		justifyContent: "center",
	},
	comment: {
		display: "flex",
		margin: theme.spacing(1), //grid padding,
		padding: theme.spacing(2),
		backgroundColor: "white",
		justifyContent: "center",
		boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
		[theme.breakpoints.down("sm")]: {
			flexDirection: "column",
			gap: "3rem",
			padding: "10px",
		},
	},
}));

export default function Comments({ sendMessages }) {
	const params = useParams();
	const classes = useStyles();
	const BaseUrl = `${url.list_issue}`;
	const BaseUrlIncident = `${url.list_incident}`;
	const fetchData = useContext(FetchDataContext);
	const {
		getFetchData,
		addData,
		addDataForm,
		updateData,
		MultiHandleOptionsTask,
		stateOption,
		incidentOption,
	} = fetchData;

	const [open, setOpen] = useState(false);
	const [images, setImages] = useState("");

	const [state, setState] = useState({
		issues: {},
		privilege: {},
		// comments: [],
		loading: false,
	});
	const [incident, setIncident] = useState({ loading: false, data: {} });
	const { issues, privilege, loading } = state;
	const [items, setItems] = useState([]);
	const [lengthComments, setLengthComments] = useState(5);

	const [limit, setLimit] = useState(5);

	const addComment = (comment, issue) => {
		setState({
			loading: false,
			// comments: [comment, ...state.comments],
			issues: issue,
		});
		loadData();
		loadIncidentData();
	};

	const handleOpenDialogImage = (rowData) => {
		setOpen(!open);
		setImages(rowData);
	};

	const handleOpenClose = () => {
		loadData();
		loadIncidentData();
		return true;
	};

	const loadData = async () => {
		const idIssue = params.id || params.issueId;

		if (!idIssue) {
			console.error("❌ Issue ID tidak ditemukan");
			return { data: { notes: [], lendata: 0, issue: {}, privilege: {} } };
		}

		try {
			let result = await getFetchData({
				url: `${BaseUrl}/notes?id=${idIssue}&limit=${limit}`,
			});
			if (result?.data) {
				setState({
					// loading: false,
					// comments: result.data.notes,
					issues: result.data.issue || [],
					privilege: result.data.privilege || {},
				});
				setItems(result.data.notes || []);
				setLengthComments(result.data.lendata || 0);
			}
			return result;
		} catch (error) {
			console.error("Error loading data:", error);
			return { data: { notes: [], lendata: 0, issue: {}, privilege: {} } };
		}
	};

	const loadIncidentData = async () => {
		const idIssue = params.id || params.issueId;

		try {
			let result = await getFetchData({
				url: `${BaseUrlIncident}/detail/${idIssue}`,
			});

			if (result?.data) {
				setIncident({
					// loading: false,
					data: result.data,
				});
			}
			// return result;
		} catch (error) {
			console.error("❌ Error loading incident data:", error);
		}
	};

	const fetchAPI = async (action, data) => {
		let result;
		if (action === "addForm")
			result = await addDataForm(`${BaseUrl}/add_notes`, data, handleOpenClose);
		if (action === "add")
			result = await addData(`${BaseUrl}/add_notes`, data, handleOpenClose);
		if (action === "editStatuNotes")
			result = await updateData(
				`${BaseUrl}/edit_issue/status?id=${data.idticket}`,
				data,
				handleOpenClose
			);
		if (action === "editStatusIssue")
			result = await updateData(
				`${BaseUrl}/edit_issue/assignee?id=${data.idticket}`,
				data,
				handleOpenClose
			);
		if (action === "addIncident")
			result = await addData(`${BaseUrlIncident}/add_kecelakaan`, data, handleOpenClose);
		return result;
	};

	useEffect(() => {
		loadData();
		loadIncidentData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Grid item className={classes.root}>
			<div className={classes.card}>
				<DialogImages
					open={open}
					handleClose={handleOpenDialogImage}
					urlGambar={images}
				/>
				<div className={classes.jumbotron}>
					<Jumbotron issues={issues} modalImage={handleOpenDialogImage} incident={incident} />
				</div>
				<Card className={classes.comment}>
					<Grid container spacing={3}>
						<Grid item lg={4} sm={12} xs={12}>
							<CommentForm
								addComment={addComment}
								MultiHandleOptionsTask={MultiHandleOptionsTask}
								fetchAPI={fetchAPI}
								issues={issues}
								privilege={privilege}
								stateOption={stateOption}
								incidentOption={incidentOption}
								sendMessages={sendMessages}
							/>
						</Grid>
						<Grid item lg={8} sm={12} xs={12}>
							<CommentList
								loading={loading}
								items={items}
								setItems={setItems}
								limit={limit}
								setLimit={setLimit}
								loadData={loadData}
								lengthComments={lengthComments}
								modalImage={handleOpenDialogImage}
							/>
						</Grid>
					</Grid>
				</Card>
			</div>
		</Grid>
	);
}
